const configure = {
    state:{
        HOST: window.location.protocol + '//' + window.location.host,  //同源访问：开发环境走 webpack 代理，生产环境由 Nginx 接管静态资源
    },
    getters: {

    },
    mutations: {

    }
}

export default configure
